import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../api/Api';
import initialState from '../constants/initialState';

// Request a password-reset email
export const requestReset = createAsyncThunk(
    'forgot/request',
    async ({ email }, thunkAPI) => {
        try {
            const result = await API.postData('venues/forgot-password', { email });
            const response = result.data;
            if (response.status) {
                return { message: response.message, delivery: response.data?.delivery };
            }
            return thunkAPI.rejectWithValue({ error: response.message });
        } catch (err) {
            return thunkAPI.rejectWithValue({ error: err.message });
        }
    }
);

// Submit a new password with a reset token
export const submitReset = createAsyncThunk(
    'forgot/reset',
    async ({ token, password }, thunkAPI) => {
        try {
            const result = await API.postData('venues/reset-password', { token, password });
            const response = result.data;
            if (response.status) {
                return { message: response.message };
            }
            return thunkAPI.rejectWithValue({ error: response.message });
        } catch (err) {
            return thunkAPI.rejectWithValue({ error: err.message });
        }
    }
);

const base = {
    ...initialState.forgotPass,
    isFetching: false,
    isSuccess: false,
    isError: false,
    message: '',
    errorMessage: '',
};

const ForgotReducer = createSlice({
    name: 'ForgotPassword',
    initialState: base,
    reducers: {
        clearForgotState(state) {
            Object.assign(state, base);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(requestReset.pending, (state) => { state.isFetching = true; state.isError = false; state.isSuccess = false; })
            .addCase(requestReset.fulfilled, (state, { payload }) => {
                state.isFetching = false; state.isSuccess = true; state.message = payload.message;
            })
            .addCase(requestReset.rejected, (state, { payload }) => {
                state.isFetching = false; state.isError = true; state.errorMessage = payload?.error || 'Something went wrong.';
            })
            .addCase(submitReset.pending, (state) => { state.isFetching = true; state.isError = false; state.isSuccess = false; })
            .addCase(submitReset.fulfilled, (state, { payload }) => {
                state.isFetching = false; state.isSuccess = true; state.message = payload.message;
            })
            .addCase(submitReset.rejected, (state, { payload }) => {
                state.isFetching = false; state.isError = true; state.errorMessage = payload?.error || 'Could not reset password.';
            });
    }
});

export const { clearForgotState } = ForgotReducer.actions;
export default ForgotReducer.reducer;
